<div class="pl-l pb-l pr-l pt-l">
    <div style="min-width: 900px">
        <!-- Title -->
        <div class="disp-f j-c-sb a-i-c">
            <div class="disp-f a-i-c j-c-c">
                <div class="disp-f a-i-c j-c-c col bkg-light-grey-2 radius-10" style="height: 45px; width: 45px;">
                    <img ngSrc="assets/icons/bullhorn.svg" class="svg-24" alt="" height="24" width="24">
                </div>
                <div class="ml-s flex-column gap-XS">
                    <div class="font-L fw-700">{{ 'page.agent.workstations.downloadPopUp.title' | translate }}</div>
                    <div class="font-M fw-300">{{ 'page.agent.workstations.downloadPopUp.subtitle' | translate }}</div>
                </div>
            </div>
            <!-- Close button -->
            <app-icon-button (click)="onClose()" [img]="'assets/icons/close.svg'" type="stroked" background [panelClass]="'img-size-30 darken-icon'"></app-icon-button>
        </div>

        <!-- Content -->
        <div class="mt-l bg-rounded inner-container pad-L" style="max-height: 70vh;overflow-y: auto">
            <div style="height:10px; position: sticky;top: 0;">
                <div class="back flex-align-center fw-700 gap-XS c-p" (click)="onClose()">
                    <img ngSrc="assets/icons/arrow-left.svg" class="filter-primary" alt="" width="10" height="10">
                    <div>{{ 'page.agent.workstations.downloadPopUp.backButton' | translate }}</div>
                </div>
            </div>
            <div class="grid-5" >
                <div class="flex flex-justify-end pad-top-L h-100 pad-right-L">
                    <div>
                        <div class="pills">1</div>
                        <div style="border-left: 1px dashed #DADADA; height: 100%; margin-left: 17px"></div>
                    </div>
                </div>
                <div class="span3 bg-rounded inner-block pad-L flex-column flex-space-between">
                    <div>
                        <div class="font-MM fw-700">{{ 'page.agent.workstations.downloadPopUp.step1Title' | translate}}</div>
                        <div class="font-S mt-xs">{{ 'page.agent.workstations.downloadPopUp.step1Subtitle' | translate}}</div>
                    </div>

                    <div class="pad-top-M">
                        <div class="pad-bottom-XS">{{ 'page.agent.workstations.downloadPopUp.OSHint' | translate}}</div>
                        <app-multi-select [inputControl]="operatingSystemForm">
                            <app-select-trigger appearance="field">{{ getPrettyOSName(operatingSystemForm.value) }}</app-select-trigger>
                            <app-select-option [value]="'windows'">{{ getPrettyOSName('windows')}}</app-select-option>
                            <app-select-option [value]="'macos'">{{ getPrettyOSName('macos') }}</app-select-option>
                        </app-multi-select>
                    </div>

                    <div class="pad-top-M">
                        <div class="pad-bottom-XS">{{ 'page.agent.workstations.downloadPopUp.architectureHint' | translate}}</div>
                        <app-multi-select [disabled]="operatingSystemForm.invalid" [inputControl]="architectureForm">
                            <app-select-trigger appearance="field">{{ getPrettyArchitectureName(architectureForm.value) }}</app-select-trigger>
                            @for (option of architectureOptions; track option) {
                                <app-select-option [value]="option">{{ getPrettyArchitectureName(option)}}</app-select-option>
                            }
                        </app-multi-select>
                    </div>

                    <div class="pad-top-M">
                        <div class="pad-bottom-XS">{{ 'page.agent.workstations.downloadPopUp.optionsHint' | translate}}</div>
                        <app-multi-select [disabled]="architectureForm.invalid" [inputControl]="optionsForm">
                            <app-select-trigger appearance="field">{{ getPrettyOptionsName(optionsForm.value) }}</app-select-trigger>
                            @for (option of optionsOptions; track option) {
                                <app-select-option [value]="option">{{ getPrettyOptionsName(option)}}</app-select-option>
                            }
                        </app-multi-select>
                    </div>

                    <div class="pad-top-M"><app-text-button (click)="download()" type="flat">{{ 'page.agent.workstations.downloadPopUp.downloadButton' | translate}}</app-text-button></div>
                </div>
                <div></div>

                <div class="flex flex-justify-end pad-top-L pad-right-L mt-l">
                    <div class="pills">2</div>
                </div>
                <div class="span3 bg-rounded pad-L flex-column mt-l">
                    <div>
                        <div class="font-MM fw-700">{{ 'page.agent.workstations.downloadPopUp.step2Title' | translate}}</div>
                        <div class="font-S mt-xs">{{ 'page.agent.workstations.downloadPopUp.step2Subtitle' | translate}}</div>
                    </div>
                    <div class="pad-top-L pad-bottom-L"><app-copy-text [text]="tenantExtensionSettings.token"></app-copy-text></div>
                </div>
                <div></div>
            </div>
        </div>
    </div>
</div>
